import React from "react";
import {Route, Switch, Redirect} from "react-router-dom";
import { ScaleConfigurationsTab } from "./ScaleConfigurationsTab";
import { PrintLayoutsTab } from "./PrintLayoutsTab";
import { PrinterConfigurationsTab } from "./PrinterConfigurationsTab";

export function ScalePrintScreen() {
  return (
    <Switch>
      <Route path="/devices" exact>
        <Redirect to="/devices/scale-configurations" />
      </Route>
      <Route path="/devices/scale-configurations" component={ScaleConfigurationsTab} />
      <Route path="/devices/print-layouts" component={PrintLayoutsTab} />
      <Route path="/devices/printer-configurations" component={PrinterConfigurationsTab} />
    </Switch>
  );
}